/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { SettingsService } from '@ithinkdt/shared/browser';
import { COMMON_COMFIG } from '@ithinkdt/shared/utils';
import { LogoutService } from '@ithinkdt/theme/fetch-service';
import { ThemeConfig, ThemeUserConfig } from '@ithinkdt/theme/models';

@Component({
  selector: 'dt-header-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  host: {
    '[class.cursor]': 'true',
  },
})
export class HeaderUserComponent implements OnInit {
  themeConfig: ThemeConfig;

  // @ViewChild('userSettingCont', { read: ViewContainerRef, static: false })
  // container: any;
  userSettingInstance: any;
  @ViewChild('resetPwdComp', { static: false }) resetPwdRef: any;
  @ViewChild('changeAccount', { static: false }) changeAccountRef: any;
  @ViewChild('bindAccount', { static: false }) bindAccount: any;

  constructor(
    private router: Router,
    public settings: SettingsService,
    // private resolver: ComponentFactoryResolver,
    private logoutService: LogoutService
  ) {
    this.themeConfig = this.settings.userConfig['theme'] || {};
  }

  ngOnInit() {
    if (this.themeConfig && this.themeConfig.userSettingComp) {
      this.userSettingInstance = this.themeConfig.userSettingComp;
    }
  }

  // createComponent() {
  //   if (this.container && this.container.clear) {
  //     this.container.clear();
  //   }
  //   console.log('this.themeConfig.userSettingComp', this.userConfig.userSettingComp);

  //   const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(this.userConfig.userSettingComp);
  //   this.container.createComponent(factory);
  // }

  logout() {
    this.logoutService.logout().subscribe((res) => {
      // if(res.status){
      this.settings.resetSettings();
      this.router.navigateByUrl(COMMON_COMFIG.LOGIN_URL);
      // }
    });
    // setTimeout(() => {
    //   // éç½®ç¼å­
    // });
  }

  resetPwd() {
    this.resetPwdRef.open();
  }

  // ç¹å»åæ¢è´¦å·
  exchangeAccount() {
    this.changeAccountRef.open();
  }

  // ç»å®äºä»¶
  bindAccounts() {
    this.bindAccount.open();
  }
}
